//@flow
import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { Box, Text } from 'gestalt';

type Props = {|
  creditNameLink?: string,
  name: string,
|};

export default function CreditName({ name, creditNameLink }: Props) {
  return (
    <Box>
      {creditNameLink ? (
        <NavigateLink className="underlineLink" stopPropagation to={creditNameLink}>
          <Text size="xs" truncate weight="bold">
            {name}
          </Text>
        </NavigateLink>
      ) : (
        <Text size="xs" truncate weight="bold">
          {name}
        </Text>
      )}
    </Box>
  );
}
